"use client";

import { ChevronRight } from "lucide-react";
import { authLinks } from "@/config/nav-links";
import { cn } from "@/lib/utils";
import { NavLoginEvent, useNavLogin } from "@/app/hooks/use-nav-login";
import { useNavThemeStyles } from "./nav-theme-context";
import { NavAvatarButton, useNavProfile } from "./nav-profile";
import TrackedLink from "./TrackedLink";

const primaryClassName =
    "bg-cta-primary text-cta-primary-text hover:bg-cta-primary-hover hover:text-cta-primary-text-hover";

const authButtonClassName =
    "inline-flex h-10 items-center justify-center gap-2 rounded-[var(--radius-m)] px-4 py-2 text-sm font-medium leading-5 no-underline transition-colors";

const NavigationAuthButtons = () => {
    const theme = useNavThemeStyles();
    const { isAuthenticated, isAuthFetched } = useNavProfile();
    const handleLogin = useNavLogin();

    if (!isAuthFetched) {
        return null;
    }

    if (isAuthenticated) {
        return <NavAvatarButton />;
    }

    return (
        <div className="hidden items-center justify-end gap-4 sm:flex">
            {authLinks.map((link, index) => {
                const isPrimary = index === 0;
                const className = cn(
                    authButtonClassName,
                    isPrimary ? primaryClassName : theme.secondaryCta,
                );

                if (link.href === "/login") {
                    return (
                        <button
                            key={link.label}
                            type="button"
                            className={className}
                            onClick={() => handleLogin(NavLoginEvent.LOGIN)}
                        >
                            {link.label}
                            <ChevronRight className="size-4 shrink-0" aria-hidden />
                        </button>
                    );
                }

                return (
                    <TrackedLink
                        key={link.href}
                        href={link.href}
                        event={link.eventName}
                        target={link.openInNewTab ? "_blank" : undefined}
                        rel={link.openInNewTab ? "noopener noreferrer" : undefined}
                        className={className}
                    >
                        {link.label}
                        <ChevronRight className="size-4 shrink-0" aria-hidden />
                    </TrackedLink>
                );
            })}
        </div>
    );
};

export default NavigationAuthButtons;
